import { Package, Truck, Timer } from "lucide-react";

const STATS = [
  { icon: Package, value: "10,000+", label: "Shipments Delivered" },
  { icon: Truck, value: "Pan India", label: "Coverage" },
  { icon: Timer, value: "On-Time", label: "Delivery Guaranteed" },
];

export function HomeBanner() {
  return (
    <section className="relative w-full overflow-hidden bg-[#0A2A5E] text-white" data-testid="home-banner">
      <div className="absolute inset-0 opacity-[0.07] pointer-events-none" style={{ backgroundImage: "repeating-linear-gradient(115deg, #fff 0 1px, transparent 1px 28px)" }} />
      <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#F97316]/20 blur-3xl pointer-events-none" />
      <div className="relative max-w-5xl mx-auto px-6 py-12 sm:py-16">
        <h2 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]" data-testid="home-banner-headline">
          Fast. Reliable. <span className="text-[#F97316]">Secure</span> Logistics Solutions
        </h2>
        <p className="mt-4 max-w-2xl text-sm sm:text-base text-blue-100/80 leading-relaxed" data-testid="home-banner-subtext">
          From single parcels to bulk shipments — we deliver across India with real-time tracking, professional handling, and guaranteed timelines.
        </p>
        <div className="mt-8 grid gap-4 sm:grid-cols-3" data-testid="home-banner-stats">
          {STATS.map((s, i) => (
            <div key={s.label} className="flex items-center gap-4 border border-white/15 bg-white/5 backdrop-blur-sm p-4" data-testid={`home-banner-stat-${i}`}>
              <div className="h-11 w-11 shrink-0 grid place-items-center bg-[#F97316] text-white"><s.icon className="h-5 w-5" /></div>
              <div className="min-w-0">
                <div className="font-heading font-black text-lg leading-tight">{s.value}</div>
                <div className="text-xs uppercase tracking-widest text-blue-100/70">{s.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeBanner;
